import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-gamepad-line text-white"></i>
              </div>
              <span className="text-white text-lg font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                GameVault
              </span>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Your trusted gaming marketplace for digital games, gift cards, and gaming accessories.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-instagram-fill"></i>
              </a>
              <a href="#" className="w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:text-white cursor-pointer">
                <i className="ri-discord-fill"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white text-sm cursor-pointer">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white text-sm cursor-pointer">Contact</Link></li>
              <li><Link to="/support" className="text-gray-400 hover:text-white text-sm cursor-pointer">Support</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-white text-sm cursor-pointer">FAQ</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white text-sm cursor-pointer">Blog</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-white font-semibold mb-4">Products</h3>
            <ul className="space-y-2">
              <li><Link to="/?category=currency" className="text-gray-400 hover:text-white text-sm cursor-pointer">V-Bucks</Link></li>
              <li><Link to="/?category=battlepass" className="text-gray-400 hover:text-white text-sm cursor-pointer">Battle Pass</Link></li>
              <li><Link to="/?category=subscription" className="text-gray-400 hover:text-white text-sm cursor-pointer">Fortnite Crew</Link></li>
              <li><Link to="/?category=giftcard" className="text-gray-400 hover:text-white text-sm cursor-pointer">Epic Gift Cards</Link></li>
            </ul>
          </div>

          {/* Business Registration */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company Info</h3>
            <div className="space-y-2 text-sm text-gray-400">
              <div>
                <span className="text-gray-300">Company:</span><br />
                BetaServeInfo Technology OU
              </div>
              <div>
                <span className="text-gray-300">Registry:</span><br />
                17191197
              </div>
              <div>
                <span className="text-gray-300">Address:</span><br />
                Harju maakond, Tallinn,<br />
                Kesklinna linnaosa,<br />
                Tartu mnt 67/1-13b, 10115
              </div>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-gray-400 hover:text-white text-sm cursor-pointer">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-400 hover:text-white text-sm cursor-pointer">Terms of Service</Link></li>
              <li><Link to="/refund" className="text-gray-400 hover:text-white text-sm cursor-pointer">Refund Policy</Link></li>
              <li><Link to="/cookies" className="text-gray-400 hover:text-white text-sm cursor-pointer">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 GameVault. All rights reserved.
          </div>
          <div className="flex items-center gap-4">
            <img src="https://public.readdy.ai/ai/img_res/acabd380384a3ca0e4e8157a66150d87.jpg" alt="Visa" className="h-6 object-contain" />
            <img src="https://readdy.ai/api/search-image?query=mastercard%20payment%20method%20logo%20on%20dark%20background%20simple%20clean&width=40&height=25&seq=mastercard&orientation=landscape" alt="Mastercard" className="h-6 object-contain" />
            <img src="https://readdy.ai/api/search-image?query=paypal%20payment%20method%20logo%20on%20dark%20background%20simple%20clean&width=40&height=25&seq=paypal&orientation=landscape" alt="PayPal" className="h-6 object-contain" />
          </div>
          <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
